import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-tab-portfolio',
  templateUrl: './profile-tab-portfolio.component.html',
  styleUrls: ['./profile-tab-portfolio.component.scss']
})
export class ProfileTabPortfolioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
